export default [
  {
    path: '/flow/edit',
    name: 'flow-edit',
    component: () => import('@/views/flows/edit/flowEdit.vue'),
  },
]
